"use strict";
/**
 * Created on 05 26 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var ProductSensitivityExportQueueRecord_1 = require("../model/ProductSensitivityExportQueueRecord");

var ProductSensitivityExportQueueRecordConverter_1 = require("./ProductSensitivityExportQueueRecordConverter");
/**
 * Implementation of {@link ProductSensitivityExportQueueRecordConverter}.
 *
 * @author JMe
 */


var ProductSensitivityExportQueueRecordConverterImpl =
/*#__PURE__*/
function (_ProductSensitivityEx) {
  _inherits(ProductSensitivityExportQueueRecordConverterImpl, _ProductSensitivityEx);

  function ProductSensitivityExportQueueRecordConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, ProductSensitivityExportQueueRecordConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSensitivityExportQueueRecordConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ProductSensitivityExportQueueRecordConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(Object.assign(result, conversions.classToDocumentId(source)), {
        state: source.state,
        created: conversions.fromDate(source.created),
        createdBy: this.userInfoConverter.toDocument(source.createdBy, conversions),
        lastModified: conversions.fromDate(source.lastModified),
        nextAttempt: conversions.fromDate(source.nextAttempt),
        attemptCount: source.attemptCount,
        requestId: source.requestId,
        error: source.error,
        filePaths: conversions.asObjectArray(source, 'filePaths', function (v) {
          return v;
        }),
        processId: source.processId
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord(ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord.schema.id.valueOf(conversions.documentToClassId(source)), ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord.schema.state.valueOfField(source), ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord.schema.created.valueOfField(source), conversions.asObject(source, 'createdBy', function (v) {
        return _this2.userInfoConverter.toObject(v, conversions);
      }), ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord.schema.lastModified.valueOfField(source), ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord.schema.nextAttempt.valueOfField(source), ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord.schema.attemptCount.valueOfField(source), ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord.schema.requestId.valueOfField(source), ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord.schema.error.valueOfField(source), ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord.schema.filePaths.valueOfField(source), ProductSensitivityExportQueueRecord_1.ProductSensitivityExportQueueRecord.schema.processId.valueOfField(source));
    }
  }]);

  return ProductSensitivityExportQueueRecordConverterImpl;
}(ProductSensitivityExportQueueRecordConverter_1.ProductSensitivityExportQueueRecordConverter);

ProductSensitivityExportQueueRecordConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], ProductSensitivityExportQueueRecordConverterImpl);
exports.ProductSensitivityExportQueueRecordConverterImpl = ProductSensitivityExportQueueRecordConverterImpl;